import _Object$assign from "babel-runtime/core-js/object/assign";
import _toConsumableArray from "babel-runtime/helpers/toConsumableArray";
import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";

var _this2 = this;

import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";
import oppService from "@/service/opp-service";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";
var SAVE_PATH2 = "";
var SAVE_PATH3 = "";

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  if (vm.$basecfg.isMobileFlag) {
    _this.groupDatas[GROUP_ID][MODULE_ID][0].MODULE_TITLE = "请仔细核对营业执照信息，如有误可点击修改";
  }

  if (_this.userType == "1") {
    fields.CUST_FNAME.VALID_TYPE = "valAX[4,120]";
    fields.ID_ADDR.VALID_TYPE = "valAX[16,80]";
    fields.CUST_NAME.VALID_TYPE = "length[4,16]", fields.BUSINESS_RANGE.VALID_TYPE = "length[0,2000]|on-blur|textarea";
    fields.ID_CODE.VALID_TYPE = "length[0,48]|on-blur";
    fields.ID_CODE.FIELD_FUNCTION = fields.ID_CODE.FIELD_FUNCTION.replace(/\|GET_ZZ_DATA/g, "") + "|GET_ZZ_DATA";
    var idTypeDict = fields.ID_TYPE.FIELD_DICT_NAME;
    idTypeDict = _.filter(idTypeDict, function (item) {
      return _this.oppBusiData.EFFECT_ID_TYPE.includes(item.DICT_ITEM) && item.DICT_ITEM[0] == "1";
    });
    fields.ID_TYPE.FIELD_DICT_NAME = idTypeDict;
    if (_this.oppBusiData.hasAppvTask1) {
      fields.CUST_FNAME.FIELD_CONTROL = "2";

      fields.ID_TYPE.FIELD_CONTROL = "2";
      fields.ID_CODE.FIELD_CONTROL = "2";
    }
  } else {
    fields.PRO_MANAGER_NAME.VALID_TYPE = "length[0,64]";
  }
};

var backfillHistoryData = function backfillHistoryData(_this) {
  var otherAgentInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH);
  var otherAgentInfo1 = _.cloneDeepGet(_this.historyData, SAVE_PATH2);
  var keyInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH3);
  if (!_.isEmpty(otherAgentInfo) && !_.isEmpty(otherAgentInfo)) {
    otherAgentInfo["CUST_FNAME"] = keyInfo["NEW_CUST_FNAME"];
    otherAgentInfo["CUST_NAME"] = keyInfo["NEW_CUST_NAME"];
    otherAgentInfo["ID_CODE"] = keyInfo["NEW_ID_CODE"];
    otherAgentInfo["ID_TYPE"] = keyInfo["NEW_ID_TYPE"];
    otherAgentInfo["CUST_FNAME_DATA_SOURCE"] = keyInfo["NEW_CUST_FNAME_DATA_SOURCE"];
    otherAgentInfo["CUST_NAME_DATA_SOURCE"] = keyInfo["NEW_CUST_NAME_DATA_SOURCE"];
    otherAgentInfo["ID_CODE_DATA_SOURCE"] = keyInfo["NEW_ID_CODE_DATA_SOURCE"];
    otherAgentInfo["ID_TYPE_DATA_SOURCE"] = keyInfo["NEW_ID_TYPE_DATA_SOURCE"];
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], otherAgentInfo);
    _this.$blMethod.parseGroupsMouduleDataSource(_this, [MODULE_ID], otherAgentInfo);
  }
  if (!_.isEmpty(otherAgentInfo1)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], otherAgentInfo1);
    _this.$blMethod.parseGroupsMouduleDataSource(_this, [MODULE_ID], otherAgentInfo1);
  }
};

var checkBusiStatus = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this) {
    var orgImpInfo, params, result, bsno;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            orgImpInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH, SAVE_PATH2, SAVE_PATH3]);
            params = {
              ID_TYPE: orgImpInfo.ID_TYPE,
              ID_CODE: orgImpInfo.ID_CODE,
              BUSI_CODE: _this.busiCode,
              CUST_FNAME: orgImpInfo.CUST_FNAME
            }, result = true;
            bsno = _this.$storage.getSession(_this.$definecfg.B_SNO);

            _this.$store.commit(_this.$types.UPDATE_LOADING, true);
            _context.next = 6;
            return _this.$syscfg.K_Request("F0000036", params).then(function (res) {
              if (res.Code == 0) {
                var dataList = res.Data.filter(function (bdata) {
                  return ["13", "15"].indexOf(bdata.PROC_STATUS) == -1;
                });
                _this.$store.commit(_this.$types.UPDATE_LOADING, false);
                if (dataList.length) {
                  if (dataList[0].B_SNO != bsno) {
                    var busiData = dataList[0];

                    _this.alert({
                      messageText: "客户有一笔在途流水未处理！流水号为：\n" + busiData.B_SNO + "，不允许重复提交!请返回首页续办!",
                      confirmButtonText: "确定",
                      msg_icon: "warn",
                      confirmedAction: function confirmedAction() {}
                    });
                    result = false;
                  } else {
                    result = true;
                  }
                } else {
                  result = true;
                }
              }
            });

          case 6:
            return _context.abrupt("return", result);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this2);
  }));

  return function checkBusiStatus(_x) {
    return _ref.apply(this, arguments);
  };
}();

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
    SAVE_PATH2 = params.savePath2;
    SAVE_PATH3 = params.savePath3;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {
    return oppService.getSysCommonParamsFromCacheObjs("MECHANISM_PRO_INVESTORS_I").then(function (val) {
      _this.oppBusiData.MECHANISM_PRO_INVESTORS_I = val;
      return initFieldConfig(_this);
    });
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
  },

  beforeSave: function beforeSave(_this, params) {
    var orgImpInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH, SAVE_PATH2, SAVE_PATH3]);
    if (orgImpInfo.ID_CODE.length == 18) {
      _this.oppBusiData.hideFields.ORG_ID_CODE = {
        value: orgImpInfo.ID_CODE.slice(8, 16) + "-" + orgImpInfo.ID_CODE.slice(16, 17),
        DATA_SOURCE: "0"
      };
    } else if (orgImpInfo.ID_CODE.length == 24) {
      _this.oppBusiData.hideFields.ORG_ID_CODE = {
        value: orgImpInfo.ID_CODE.slice(15, 23) + "-" + orgImpInfo.ID_CODE.slice(23, 24),
        DATA_SOURCE: "0"
      };
    }

    var keyInfoArr = ["NEW_CUST_FNAME", "NEW_CUST_NAME", "NEW_ID_TYPE", "NEW_ID_CODE", "ORG_ENGLISH_NAME"],
        basicInfoArr = ["SUBJECT_IDENTITY", "ID_EXP_DATE", "BIRTHDAY", "ID_ADDR", "ID_BEG_DATE", "NATIVE_PLACE", "INOUTSIDE_IDENTITY", "OPEN_SOURCE", "ORG_ID_CODE", "ORG_ID_EXP_DATE", "BUSINESS_TAX_NO", "TAX_NO_EXP_DATE", "LAND_TAX_NO", "LAND_TAX_NO_EXP_DATE", "ID_ADDR2", "IS_GROUP_TYPE"],
        keyInfoArrDataSource = _.map(keyInfoArr, function (item) {
      return item + "_DATA_SOURCE";
    }),
        basicInfoArrUpdateFlag = _.map(basicInfoArr, function (item) {
      return item + "_UPDATE_FLAG";
    }),
        basicInfoArrDataSource = _.map(basicInfoArr, function (item) {
      return item + "_DATA_SOURCE";
    });

    keyInfoArr = [].concat(_toConsumableArray(keyInfoArr), _toConsumableArray(keyInfoArrDataSource));
    basicInfoArr = [].concat(_toConsumableArray(basicInfoArr), _toConsumableArray(basicInfoArrDataSource), _toConsumableArray(basicInfoArrUpdateFlag));

    var customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO) || {};
    _Object$assign(customerInfo, {
      CUST_FNAME: orgImpInfo.CUST_FNAME,
      CUST_NAME: orgImpInfo.CUST_NAME,
      ID_TYPE: orgImpInfo.ID_TYPE,
      ID_CODE: orgImpInfo.ID_CODE
    });
    var ymtTrdacctType = _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE_ZD[0].FIELDS.YMT_TRDACCT_TYPE.DEFAULT_VALUE,
        ymtCode = _this.groupDatas.OCR_ORG_INFO_PAGE.IMPORTANT_MODULE_ZD[0].FIELDS.YMT_TRDACCT_CODE.DEFAULT_VALUE;

    if (ymtTrdacctType && ymtTrdacctType == "08" && ymtCode) {
      customerInfo.YMT_CODE = ymtCode;
    }
    _this.$store.commit(_this.$types.UPDATE_CUSTOMER_INFO, customerInfo);

    if (!params.BIZ_DATA) {
      params.BIZ_DATA = {};
    }
    if (!params.DETAIL_DATA) {
      params.DETAIL_DATA = {};
    }

    params.DETAIL_DATA.COMPANY_BASIC_INFO = _this.oppBusiData.companyBasicInfo;

    orgImpInfo.NEW_CUST_FNAME = orgImpInfo.CUST_FNAME;
    orgImpInfo.NEW_CUST_FNAME_DATA_SOURCE = orgImpInfo.CUST_FNAME_DATA_SOURCE;
    orgImpInfo.NEW_CUST_NAME = orgImpInfo.CUST_NAME;
    orgImpInfo.NEW_CUST_NAME_DATA_SOURCE = orgImpInfo.CUST_NAME_DATA_SOURCE;
    orgImpInfo.NEW_ID_TYPE = orgImpInfo.ID_TYPE;
    orgImpInfo.NEW_ID_TYPE_DATA_SOURCE = orgImpInfo.ID_TYPE_DATA_SOURCE;
    orgImpInfo.NEW_ID_CODE = orgImpInfo.ID_CODE;
    orgImpInfo.NEW_ID_CODE_DATA_SOURCE = orgImpInfo.ID_CODE_DATA_SOURCE;

    orgImpInfo["NATIVE_PLACE"] = "";

    if (orgImpInfo.ID_TYPE != 14) {
      orgImpInfo.INOUTSIDE_IDENTITY = "0";
    } else {
      orgImpInfo.INOUTSIDE_IDENTITY = "1";
    }
    orgImpInfo["OPEN_SOURCE"] = "2", orgImpInfo.ORG_ID_CODE_DATA_SOURCE = orgImpInfo.ID_CODE_DATA_SOURCE;
    orgImpInfo.ORG_ENGLISH_NAME = _this.oppBusiData.hideFields.ORG_ENGLISH_NAME && _this.oppBusiData.hideFields.ORG_ENGLISH_NAME.value;
    orgImpInfo.ORG_ENGLISH_NAME_DATA_SOURCE = _this.oppBusiData.hideFields.ORG_ENGLISH_NAME && _this.oppBusiData.hideFields.ORG_ENGLISH_NAME.DATA_SOURCE;
    orgImpInfo.LAND_TAX_NO_DATA_SOURCE = orgImpInfo.BUSINESS_TAX_NO_DATA_SOURCE = orgImpInfo.ID_CODE_DATA_SOURCE;
    orgImpInfo.ORG_ID_EXP_DATE_DATA_SOURCE = orgImpInfo.LAND_TAX_NO_EXP_DATE_DATA_SOURCE = orgImpInfo.TAX_NO_EXP_DATE_DATA_SOURCE = orgImpInfo.ID_EXP_DATE_DATA_SOURCE;
    orgImpInfo.ID_ADDR2 = orgImpInfo.ID_ADDR;
    orgImpInfo.ID_ADDR2_DATA_SOURCE = orgImpInfo.ID_ADDR_DATA_SOURCE;
    orgImpInfo.SUBJECT_IDENTITY = "";

    if (["14", "19", "1Z"].indexOf(orgImpInfo.NEW_ID_TYPE) > -1) {
      orgImpInfo.IS_GROUP_TYPE = "0";
      orgImpInfo.BUSINESS_TAX_NO = "";
      orgImpInfo.LAND_TAX_NO = "";
      orgImpInfo.TAX_NO_EXP_DATE = "";
      orgImpInfo.LAND_TAX_NO_EXP_DATE = "";
      orgImpInfo.ORG_ID_EXP_DATE = "";
      orgImpInfo.ORG_ID_CODE = "";
    } else {
      if ([18, 24].indexOf(orgImpInfo.NEW_ID_CODE.length) > -1) {
        orgImpInfo.BUSINESS_TAX_NO = orgImpInfo.ID_CODE;
        orgImpInfo.BUSINESS_TAX_NO_DATA_SOURCE = orgImpInfo.ID_CODE_DATA_SOURCE;


        orgImpInfo.LAND_TAX_NO = orgImpInfo.ID_CODE;
        orgImpInfo.LAND_TAX_NO_DATA_SOURCE = orgImpInfo.ID_CODE_DATA_SOURCE;


        orgImpInfo.ORG_ID_EXP_DATE = orgImpInfo.LAND_TAX_NO_EXP_DATE = orgImpInfo.TAX_NO_EXP_DATE = orgImpInfo.ID_EXP_DATE;
        orgImpInfo.ORG_ID_EXP_DATE_DATA_SOURCE = orgImpInfo.LAND_TAX_NO_EXP_DATE_DATA_SOURCE = orgImpInfo.TAX_NO_EXP_DATE_DATA_SOURCE = orgImpInfo.ID_EXP_DATE_DATA_SOURCE;


        orgImpInfo.ORG_ID_CODE = orgImpInfo.NEW_ID_CODE.length === 24 ? orgImpInfo.NEW_ID_CODE.substring(14, 22) + "-" + orgImpInfo.NEW_ID_CODE.substring(22, 23) : orgImpInfo.NEW_ID_CODE.substring(8, 16) + "-" + orgImpInfo.NEW_ID_CODE.substring(16, 17);

        orgImpInfo.IS_GROUP_TYPE = "1";
      } else {
        orgImpInfo.IS_GROUP_TYPE = "0";
        orgImpInfo.BUSINESS_TAX_NO = "";
        orgImpInfo.LAND_TAX_NO = "";
        orgImpInfo.TAX_NO_EXP_DATE = "";
        orgImpInfo.LAND_TAX_NO_EXP_DATE = "";
        orgImpInfo.ORG_ID_EXP_DATE = "";
        orgImpInfo.ORG_ID_CODE = "";
      }
    }

    params.ID_EXP_DATE = orgImpInfo.ID_EXP_DATE;

    bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH, SAVE_PATH2, SAVE_PATH3], orgImpInfo);

    _.set(params, SAVE_PATH3, _Object$assign(_.get(params, SAVE_PATH3, {}), _.pick(orgImpInfo, keyInfoArr)));

    _.set(params, SAVE_PATH, _Object$assign(_.get(params, SAVE_PATH, {}), _.pick(orgImpInfo, basicInfoArr)));

    _.set(params, SAVE_PATH2, _Object$assign(_.get(params, SAVE_PATH2, {}), {
      BUSINESS_RANGE: orgImpInfo.BUSINESS_RANGE,
      BUSINESS_RANGE_DATA_SOURCE: orgImpInfo.BUSINESS_RANGE_DATA_SOURCE,
      BUSINESS_RANGE_UPDATE_FLAG: orgImpInfo.BUSINESS_RANGE_UPDATE_FLAG
    }));

    _.set(params, "BIZ_DATA.STK_SETT_MODE", "");

    _.set(params, "BIZ_DATA.OPEN_CLS", "1");
  },
  validate: function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this) {
      var orgImpInfo, params, result, res;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              orgImpInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH, SAVE_PATH2, SAVE_PATH3]);
              params = {
                ORG_CODE: _this.$storage.getSession(_this.$definecfg.F_CUST_ORG_CODE),
                ID_TYPE: orgImpInfo.ID_TYPE,
                ID_CODE: orgImpInfo.ID_CODE,
                BUSI_CODE: _this.busiCode
              };
              _context2.next = 4;
              return checkBusiStatus(_this);

            case 4:
              result = _context2.sent;

              if (result) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt("return", false);

            case 7:
              if (!(params.ID_TYPE == "10")) {
                _context2.next = 13;
                break;
              }

              _this.$store.commit(_this.$types.UPDATE_LOADING, "正在进行营业执照核查");
              _context2.next = 11;
              return _this.$syscfg.K_Request("F0000060", { scCode: params.ID_CODE });

            case 11:
              res = _context2.sent;

              if (res.Code == 0) {
                if (res.Data[0].flag == "0") {
                  _this.oppBusiData.validateResArr.push({
                    alertType: "confirm",
                    messageText: "\u60A8\u5F55\u5165\u7684\u7EDF\u4E00\u793E\u4F1A\u4FE1\u7528\u4EE3\u7801\u201C" + params.ID_CODE + "\u201D\u4E0D\u7B26\u5408\u5176\u6821\u9A8C\u89C4\u5219\uFF0C\u8BF7\u786E\u8BA4\u662F\u5426\u6B63\u786E\u3002"
                  });
                }
              }

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function validate(_x3) {
      return _ref2.apply(this, arguments);
    }

    return validate;
  }(),
  "CHECK_ID_CODE": function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3(_this, field, fieldData) {
      var data;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (field.DEFAULT_VALUE) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              data = {
                orgnum: field.DEFAULT_VALUE
              };

              if (field.DEFAULT_VALUE.length == 18) {
                _this.oppBusiData.hideFields.ORG_ID_CODE = {
                  value: field.DEFAULT_VALUE.slice(8, 16) + "-" + field.DEFAULT_VALUE.slice(16, 17),
                  DATA_SOURCE: "0"
                };
              } else if (field.DEFAULT_VALUE.length == 24) {
                _this.oppBusiData.hideFields.ORG_ID_CODE = {
                  value: field.DEFAULT_VALUE.slice(15, 23) + "-" + field.DEFAULT_VALUE.slice(23, 24),
                  DATA_SOURCE: "0"
                };
              }

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function CHECK_ID_CODE(_x4, _x5, _x6) {
      return _ref3.apply(this, arguments);
    }

    return CHECK_ID_CODE;
  }(),
  "GET_ZZ_DATA": function () {
    var _ref4 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee4(_this, field, fieldData) {
      var data, result;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!vm.$basecfg.isMobileFlag) {
                _context4.next = 2;
                break;
              }

              return _context4.abrupt("return");

            case 2:
              if (field.DEFAULT_VALUE) {
                _context4.next = 4;
                break;
              }

              return _context4.abrupt("return");

            case 4:
              data = {
                orgnum: field.DEFAULT_VALUE
              };
              result = checkBusiStatus(_this);

              if (result) {
                _context4.next = 8;
                break;
              }

              return _context4.abrupt("return");

            case 8:
              _this.$store.commit(_this.$types.UPDATE_LOADING, "正在查询中证数据...");
              return _context4.abrupt("return", _this.$syscfg.K_Request("F0000051", data).then(function (res) {
                _this.$store.state.openAcctType != 3 && _this.$store.commit(_this.$types.UPDATE_LOADING, false);
                if (res.Code == 0) {
                  var basicInfo = res.Data[0];
                  if (basicInfo) {
                    _this.oppBusiData.companyBasicInfo = basicInfo;
                    _this.oppBusiData.basicInfo = basicInfo;

                    _this.$blMethod.backFillCompanyInfo(_this, basicInfo);
                  } else {
                    _this.alert("中证信息查询为空，请确认证件号码输入正确！");
                  }

                  if (_this.$store.state.openAcctType == 3) {}
                }
              }).catch(function (err) {
                consoleLog("查询中证信息失败", err.toString());
              }).finally(function () {
                _this.$store.commit(_this.$types.UPDATE_LOADING, false);
              }));

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function GET_ZZ_DATA(_x7, _x8, _x9) {
      return _ref4.apply(this, arguments);
    }

    return GET_ZZ_DATA;
  }(),
  "CHECK_ID_TYPE": function CHECK_ID_TYPE(_this, field, fieldData) {
    fieldData.ID_CODE.DEFAULT_VALUE = "";
    if (field.DEFAULT_VALUE == "10") {
      fieldData.ID_CODE.VALID_TYPE = "code_fixed_len[18,24]|on-blur";
    } else {
      fieldData.ID_CODE.VALID_TYPE = "length[0,48]|on-blur";
    }
  },
  pageActivated: function pageActivated(_this) {},
  afterSave: function afterSave(_this, newData) {},
  beforeSkipBiz: function beforeSkipBiz(_this) {}
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/bizOcrInfo/bizOrgImportantInfoNode.js
// module id = 201
// module chunks = 2